import { axios } from './axios';
import { handleErrors } from './utils';

const BASE_PATH = '/mailing/v2/provider/domain';

export function listDomains() {
    return new Promise((resolve, reject) => {
        axios
            .get(BASE_PATH)
            .then((response) => resolve(response.data))
            .catch(handleErrors(reject));
    });
}

export function getDomain(id) {
    return new Promise((resolve, reject) => {
        axios
            .get(`${BASE_PATH}/${id}`)
            .then((response) => resolve(response.data))
            .catch(handleErrors(reject));
    });
}

export function createDomain(data) {
    return new Promise((resolve, reject) => {
        axios
            .post(BASE_PATH, data)
            .then((response) => resolve(response.data))
            .catch(handleErrors(reject));
    });
}

export function deleteDomain(id) {
    return new Promise((resolve, reject) => {
        axios
            .delete(`${BASE_PATH}/${id}`)
            .then((response) => resolve(response.data))
            .catch(handleErrors(reject));
    });
}

export function validateDomain(id) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${BASE_PATH}/${id}/validate`)
            .then((response) => {
                resolve(response.data.valid);
            })
            .catch(handleErrors(reject));
    });
}
